// extracted by mini-css-extract-plugin
export default {"DetailsRows":"DetailsRow_DetailsRows__BJ3Oy","Row":"DetailsRow_Row__f-K5T","Column":"DetailsRow_Column__Eo2c1"};